import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Tramite } from './tramite.models';

export interface TramiteState extends EntityState<Tramite> {
  loaded?: boolean
  isLoading: boolean;
  error?: Error | null;
}

export const tramiteAdapter: EntityAdapter<Tramite> =
  createEntityAdapter<Tramite>({
    selectId: (model) => model.id,
    sortComparer: (a: Tramite, b: Tramite): number =>
      b.id.toString().localeCompare(a.id.toString())
  });

export const tramiteInitialState: TramiteState =
  tramiteAdapter.getInitialState({
    isLoading: false,
    error: null
  });
